// @flow
import React from 'react'

type TileProps = {
  checked: boolean,
  enabled: boolean,
  icon: string,
  id: string,
  label: string,
  name: string,
  onChange: (boolean) => void,
  value: string,
}

const CheckboxTile = (props: TileProps) => {
  const handleOnchange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    props.onChange(event.target.checked)
  }

  const { label, checked, id, name, enabled, icon } = props
  return (
    <div className='col-4 col-sm-2 mr-4' key={label}>
      <div className='custom-control custom-checkbox checkbox-image with-bg' onClick={() => { props.onChange(!checked) }}>
        <input
          checked={checked}
          className='custom-control-input'
          data-hj-whitelist
          id={id}
          name={name}
          onChange={handleOnchange}
          readOnly={!enabled}
          type='checkbox'
        />
        <label className='custom-control-label' htmlFor={id}>
          <span className='image'>
            {icon && <span className={icon}/>}
            <span className='label'>{label}</span>
          </span>
        </label>
      </div>
    </div>
  )
}

export default CheckboxTile
